import styled from "styled-components";
import { FlexRow } from "styles/layout";
import { BoldableCell } from "styles/text";
import { Theme } from "theme";
import { TrackName } from "../styles";

export const TrackStatsTable = styled.table`
  text-align: center;
`;

export const TrackStatsCenterCell = styled.td`
  width: 216px;

  @media (max-width: 700px) {
    width: 205px;
  }

  @media (max-width: 500px) {
    width: 150px;
  }
`;

export const CenterText = styled.span`
  @media (max-width: 700px) {
    font-size: 11pt;
  }

  @media (max-width: 500px) {
    font-size: 10.5pt;
    flex-grow: 1;
  }
`;
export const SetTrackName = styled(TrackName)<{
  teamOnePick: boolean | undefined;
}>`
  @media (max-width: 600px) {
    ${({ teamOnePick }) => teamOnePick && "padding-right: 25px;"};
    ${({ teamOnePick }) =>
      !teamOnePick && teamOnePick !== undefined && "padding-left: 25px;"};
  }

  @media (max-width: 400px) {
    ${({ teamOnePick }) => teamOnePick && "padding-right: 22px;"};
    ${({ teamOnePick }) =>
      !teamOnePick && teamOnePick !== undefined && "padding-left: 22px;"};
  }

  ${({ teamOnePick }) => teamOnePick && "padding-right:31px;"}
  ${({ teamOnePick }) =>
    !teamOnePick && teamOnePick !== undefined && "padding-left:31px;"}
`;

export const PickingTeamLogoContainer = styled.div<{
  teamOnePick: boolean | undefined;
  played: boolean;
}>`
  width: 26px;
  height: 26px;

  @media (max-width: 600px) {
    width: 21px;
    height: 21px;

    ${({ teamOnePick }) => teamOnePick && "padding-right: 4px;"};
    ${({ teamOnePick }) =>
      !teamOnePick && teamOnePick !== undefined && "padding-left: 4px;"};
  }

  @media (max-width: 400px) {
    width: 19px;
    height: 19px;

    ${({ teamOnePick }) => teamOnePick && "padding-right: 3px;"};
    ${({ teamOnePick }) =>
      !teamOnePick && teamOnePick !== undefined && "padding-left: 3px;"};
  }

  ${({ teamOnePick }) => teamOnePick && "padding-right: 5px;"};
  ${({ teamOnePick }) =>
    !teamOnePick && teamOnePick !== undefined && "padding-left: 5px;"};

  ${({ played }) => !played && "opacity: 0.6;"}
`;

export const BannedTrackNameCell = styled.td<{ leftAlign: boolean }>`
  min-width: 125px;
  display: flex;
  justify-content: right;
  ${({ leftAlign }) => leftAlign && "justify-content: left"}
`;

export const BanIcon = styled.img`
  width: 26px;
  height: 26px;
  padding: 0 8px;
  filter: brightness(50%);

  @media (max-width: 700px) {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 600px) {
    width: 18px;
    height: 18px;
  }
`;

export const BansText = styled.span`
  font-size: 15pt;
  color: ${Theme.bannedTrackTextColor};
  font-weight: bold;
  margin-bottom: 3px;

  @media (max-width: 700px) {
    font-size: 13pt;
  }

  @media (max-width: 600px) {
    font-size: 11pt;
  }
`;

export const TeamTrackPointsCell = styled.td<{ winner: boolean }>`
  width: 100px;
  font-size: 15pt;
  @media (max-width: 600px) {
    font-size: 13.5pt;
  }

  @media (max-width: 500px) {
    font-size: 12.5pt;
  }

  ${({ winner }) => winner && "font-weight: bold"}
`;

export const TeamTrackPointsCellContents = styled(FlexRow)<{
  leftAlign: boolean;
}>`
  justify-content: right;
  ${({ leftAlign }) => leftAlign && "justify-content: left"}
`;

export const UnfinishedTeamTrackPointsCell = styled(TeamTrackPointsCell)`
  color: dimgray;
`;

export const AceContainer = styled(FlexRow)`
  padding: 1px 8px 0 8px;
  column-gap: 2px;

  @media (max-width: 600px) {
    padding: 1px 6px 0 6px;
  }
`;

export const AceIcon = styled.img`
  width: 13px;
  height: 16px;
  opacity: 0.85;

  @media (max-width: 600px) {
    width: 11px;
    height: 14px;
  }
`;

export const DnfContainer = styled(FlexRow)<{
  justify: "left" | "right";
}>`
  flex-grow: 1;
  flex-basis: 0;
  padding: 0 6px;
  color: maroon;
  justify-content: ${({ justify }) => justify};

  @media (max-width: 500px) {
    display: none;
  }
`;

export const PlayerCell = styled.td<{ textAlign: "left" | "right" }>`
  text-align: ${({ textAlign }) => textAlign};
  width: 75px;
  max-width: 75px;
  min-width: 75px;
  padding: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;

  @media (max-width: 700px) {
    width: 70px;
    max-width: 70px;
    min-width: 70px;
    font-size: 11pt;
  }

  @media (max-width: 500px) {
    width: 60px;
    max-width: 60px;
    min-width: 60px;
    font-size: 10pt;
  }
`;

export const SetMatchTimeCell = styled(BoldableCell)`
  width: 66px;

  @media (max-width: 700px) {
    width: 62px;
    font-size: 11pt;
  }

  @media (max-width: 500px) {
    width: 50px;
    font-size: 9pt;
  }
`;

export const TimeDifferenceCell = styled.td<{
  leftAlign: boolean;
}>`
  padding: 0 2px 0 18px;
  ${({ leftAlign }) => leftAlign && "padding: 0 18px 0 2px"};

  @media (max-width: 600px) {
    font-size: 0;
    padding: 0;
  }
`;

export const PaddingRow = styled.tr`
  height: 6px;

  @media (max-width: 700px) {
    height: 4px;
  }
`;
